import { useDecision } from '@optimizely/react-sdk';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { dealSelectors } from '@/builders/deals/slice/deal.slice';

interface UseHidePriceHardCoding {
  shouldHidePrice: boolean;
  isDealTile: boolean;
}

const useHidePriceHardCoding = (name?: string, productId?: string, isDeal = false): UseHidePriceHardCoding => {
  const [{ enabled: showAllDealRecipePrices }] = useDecision('cb-show_all_deal_recipe_prices');

  const deal = useSelector(dealSelectors.selectDeal);

  const isDealPizzaRecipe = useMemo(() => !!deal?.data?.steps?.some((dealStep) => !!dealStep?.recipeOptions?.some((recipe) => recipe.id === productId && recipe.type === 'PIZZA')),
    [deal?.data?.steps, productId]);

  const shouldHideDealRecipePrices = isDealPizzaRecipe && !showAllDealRecipePrices;
  return {
    shouldHidePrice: shouldHideDealRecipePrices,
    isDealTile: !isDealPizzaRecipe
  };
};

export default useHidePriceHardCoding;
